import * as ng from '@angular/core';
import {Component, Output, EventEmitter} from '@angular/core';
import {LiveUserAuthority} from "../../../lib/entity/live-user-authority";
import {environment} from "../../../env/environment";

@Component({
  selector: 'maglive-follow-dialog',
  templateUrl: './follow-dialog.component.html',
  styleUrls: ['./follow-dialog.component.scss']
})
export class FollowDialogComponent {
  @ng.Input()
  authority: LiveUserAuthority | "NOT_LOGIN";
  @Output() dismiss = new EventEmitter();

  dismissModal() {
    this.dismiss.emit()
  }

  login() {
    window.location.href = environment.baseURL.mag2mypage + 'Welcome.do?ref=' + encodeURIComponent(window.location.href)
    return false
  }
}
